module.exports = __webpack_public_path__ + "img/litecoin.92b656b6.svg";